import { useOutOfPolicyExpense } from "@common/state/outOfPolicyState";
import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { Body } from "@hypercard/web-components";
import {
  Expense,
  ExpenseReportStatus,
  ExpenseStatus,
} from "@common/utils/graphql";
import { Info } from "@phosphor-icons/react";
import { cn } from "@/utils/utils";
import { StatusText } from "@common/components/StatusText";
import { Pick } from "@react-spring/web";

type Props = {
  expense: Pick<Expense, "status" | "id"> & {
    report: Pick<Expense["report"], "status" | "isAutoApproved">;
  };
  small?: boolean;
};

type Statuses = {
  status: ExpenseStatus | ExpenseReportStatus;
  displayStatus?: string;
};

export const ExpenseStatusText = ({ expense, small }: Props) => {
  const { isExpenseOutOfPolicy, getExpenseOutOfPolicyReason } =
    useOutOfPolicyExpense();
  const bodySize = small ? "sm" : "md";
  const iconSize = small ? "size-4" : "size-6";

  const preventHidingToast = (
    e:
      | CustomEvent<{ originalEvent: PointerEvent }>
      | React.MouseEvent<HTMLButtonElement>,
  ) => {
    e.preventDefault();
  };

  if (isExpenseOutOfPolicy(expense)) {
    return (
      <div className={cn("flex items-center gap-2", { "gap-2": small })}>
        <Body size={bodySize} weight="regular" className="text-error">
          Out of Policy
        </Body>
        <Tooltip delayDuration={100}>
          <TooltipTrigger onClick={preventHidingToast}>
            <Info className={iconSize} />
          </TooltipTrigger>
          <TooltipContent
            onPointerDownOutside={preventHidingToast}
            className="max-w-[200px]"
          >
            <Body size="sm" weight="medium">
              {getExpenseOutOfPolicyReason(expense)}
            </Body>
            <TooltipArrow />
          </TooltipContent>
        </Tooltip>
      </div>
    );
  }

  const { status, displayStatus = status }: Statuses =
    expense.report.status === ExpenseReportStatus.Draft
      ? expense.report
      : expense;
  return (
    <StatusText
      status={status}
      displayStatus={displayStatus}
      size={bodySize}
      isAutoApproved={expense.report.isAutoApproved}
    />
  );
};
